import { render, staticRenderFns } from "./GroupShow.vue?vue&type=template&id=4f6ebb87&scoped=true&"
import script from "./GroupShow.vue?vue&type=script&lang=ts&"
export * from "./GroupShow.vue?vue&type=script&lang=ts&"
import style0 from "./GroupShow.vue?vue&type=style&index=0&id=4f6ebb87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6ebb87",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VCardText,VContainer,VDataTable,VSkeletonLoader})
